<template>
    <page
      :empty="!machines.length > 0"
      empty-text="Leider gibt es derzeit keine Maschinen zu sehen.">
        <div class="machine-listing scroll-performance">
            <Card
              v-for="(machine, index) in machines"
              :key="index"
              :index="index"
              :machine="machine"></Card>
        </div>
    </page>
</template>

<script type="text/babel">
import Card from './Card.vue';
import Page from '../Page.vue';

export default {
  name: 'Machines',
  components: {
    Card,
    Page,
  },
  data() {
    return {};
  },
  computed: {
    machines() {
      return this.$store.getters.getMachines;
    },
  },
};
</script>

<style lang="scss">
    :root {
        --machines-per-row: 5;
        @media screen and (max-width: 100em) {
            --machines-per-row: 4;
        }
        @media screen and (max-width: 80em) {
            --machines-per-row: 3;
        }
        @media screen and (max-width: 65em) {
            --machines-per-row: 2;
        }
    }
    .machine-listing {
        padding: 1em;
        overflow: auto;
        display: grid;
        grid-auto-rows: max-content;
        grid-template-columns: repeat(var(--machines-per-row), 1fr);
        grid-gap: 1em;
    }
</style>
